module.exports = __webpack_public_path__ + "static/img/gprs-case.82c410fe.jpg";